import React, { useCallback, useState } from 'react'
import withServices from '../../hocs/withServices'
import { Backdrop, Button, Checkbox, Container, Fade, FormControlLabel, Grid, MenuItem, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form';
import { Skeleton } from '@material-ui/lab';
import { useAlert } from '../../hooks/useAlert';

const AetPoints = ({ services }) => {
    const { control, handleSubmit } = useForm();
    const showAlert = useAlert();
    const { control: addmissionControl, setValue, handleSubmit: handleSubmitAdmission } = useForm();
    const [abiturs, setAbiturs] = useState([]);
    const [admission, setAdmission] = useState({});
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const onSubmit = useCallback((data) => {
        setLoading(true);
        services.secretary.getEnrolless({
            ...data,
            application_year: localStorage.getItem("AdmissionOfYear"),
        })
            .then(({ data }) => {
                setAbiturs(data.list);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [services.secretary]);

    const onUpdatePoints = (data) => {
        services.secretary.changePoints(admission.user.id, data.englishPoint, data.ictPoint)
            .then(() => {
                showAlert('Баллы успешно обновлены!', 'success')
                handleClose();
            });
    }



    const handleOpen = (userId) => {
        setOpen(true);
        services.secretary.getAdmission(userId)
            .then(({ data }) => {
                setValue("englishPoint", data.aetEnglishPoint);
                setValue("ictPoint", data.aetICTPoint);
                setAdmission(data);
            });
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <Container component="main" maxWidth="xl">
            <Typography variant="h5">Изменение баллов АЕТ</Typography>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid item xs={12} style={{ marginBottom: 20 }}>
                    <Grid container spacing={3}>
                        <Grid item lg={6} xs={12}>
                            <Controller
                                name="keyword"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        placeholder="Введите ваш запрос"
                                        style={{ width: "70%" }}
                                    />
                                )}
                            />
                            <Controller
                                name="type"
                                control={control}
                                defaultValue="FIO"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        select
                                        style={{ width: "30%" }}
                                    >
                                        <MenuItem value="FIO">Полное имя</MenuItem>
                                        <MenuItem value="iin">ИИН</MenuItem>
                                        <MenuItem value="locality">Город</MenuItem>
                                    </TextField>
                                )}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <Controller
                                name="englishCertification"
                                control={control}
                                defaultValue={false}
                                render={({ field }) => (
                                    <FormControlLabel
                                        style={{ float: "right", textAlign: "center" }}
                                        control={
                                            <Checkbox
                                                {...field}
                                                checked={field.value}
                                                color="primary"
                                            />
                                        }
                                        label="Имеется сертификат"
                                    />
                                )}
                            />
                            <Controller
                                name="fullness"
                                control={control}
                                defaultValue={false}
                                render={({ field }) => (
                                    <FormControlLabel
                                        style={{ float: "right", textAlign: "center" }}
                                        control={
                                            <Checkbox
                                                {...field}
                                                checked={field.value}
                                                color="primary"
                                            />
                                        }
                                        label="Все данные заполнены"
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Button type="submit" variant="contained" color="primary">
                    Поиск
                </Button>
            </form>

            <Table aria-label="student table">
                <TableHead>
                    <TableRow>
                        <TableCell>Фамилия</TableCell>
                        <TableCell>Имя</TableCell>
                        <TableCell>Отчество</TableCell>
                        <TableCell align="right">Электронная почта</TableCell>
                        <TableCell align="right">Номер телефона</TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableHead>

                {loading ? (
                    <TableBody>
                        {[...Array(10)].map((x, i) => {
                            return (
                                <TableRow key={i}>
                                    <TableCell component="th" scope="row">
                                        <Skeleton variant="text" />
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        <Skeleton variant="text" />
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        <Skeleton variant="text" />
                                    </TableCell>
                                    <TableCell style={{ width: 160 }} align="right">
                                        <Skeleton variant="text" />
                                    </TableCell>
                                    <TableCell style={{ width: 160 }} align="right">
                                        <Skeleton variant="text" />
                                    </TableCell>
                                    <TableCell align="right">
                                        <Skeleton variant="text" />
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                ) : (
                    <TableBody>
                        {abiturs && abiturs?.map(
                            ({ id, surname, name, patronymic, email, phoneNumber }) => (
                                <TableRow key={id}>
                                    <TableCell component="th" scope="row">
                                        {surname}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {name}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {patronymic}
                                    </TableCell>
                                    <TableCell style={{ width: 160 }} align="right">
                                        {email}
                                    </TableCell>
                                    <TableCell style={{ width: 160 }} align="right">
                                        {phoneNumber}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => handleOpen(id)}
                                        >
                                            Баллы АЕТ
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                    </TableBody>
                )}
            </Table>
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Fade in={open}>
                    {admission && (
                        <form onSubmit={handleSubmitAdmission(onUpdatePoints)}>
                            <Container maxWidth="sm" style={{ backgroundColor: 'white', padding: '20px', outline: 'none' }}>
                                <Typography variant="h6" gutterBottom>
                                    Баллы АЕТ
                                </Typography>
                                <Controller
                                    name="englishPoint"
                                    control={addmissionControl}
                                    defaultValue={admission.aetEnglishPoint}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Баллы по английскому"
                                            InputLabelProps={{ shrink: true }}
                                            defaultValue={admission.aetEnglishPoint}
                                            placeholder="Введите баллы по английскому"
                                            fullWidth
                                        />
                                    )}
                                />
                                <Controller
                                    name="ictPoint"
                                    control={addmissionControl}
                                    defaultValue={admission.aetICTPoint}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Баллы по ИКТ"
                                            InputLabelProps={{ shrink: true }}
                                            placeholder="Введите баллы по ИКТ"
                                            fullWidth
                                        />
                                    )}
                                />
                                <div style={{ display: "flex", flexDirection: "column", marginTop: '20px' }}>
                                    <Button type="submit" variant="contained" color="primary">
                                        Сохранить
                                    </Button>
                                    <Button onClick={handleClose} variant="contained" color="secondary" >
                                        Закрыть
                                    </Button>
                                </div>
                            </Container>
                        </form>
                    )}
                </Fade>
            </Modal>
        </Container >
    )
}

export default withServices()(AetPoints)